import moment from "moment";
import {
  getClearPeriodDateRange,
  resolveDeleteRangeIsShift,
} from "./eventsWorkspaceClear.utils";
import { getPublishPeriodDetails } from "./eventsWorkspacePublish.utils";

const EVENT_SHIFT_VIEW = {
  DAILY: "3",
  MONTHLY: "2",
  WEEKLY: "4",
};

/** Max length for SchedulerTemplate `Name`. */
export const SCHEDULER_TEMPLATE_NAME_MAX_LENGTH = 100;

/**
 * Maps calendar view id to API `TemplateViewType`:
 * Week = 1, Month = 2, Daily = 3.
 * @param {string} calendarViewId
 * @returns {number}
 */
export function getSchedulerTemplateViewType(calendarViewId) {
  if (calendarViewId === EVENT_SHIFT_VIEW.MONTHLY) return 2;
  if (calendarViewId === EVENT_SHIFT_VIEW.DAILY) return 3;
  return 1; // Week
}

/**
 * Modal title / intro for Save Day/Week/Month as Template.
 * Template name starts empty; users must enter a name before saving.
 * @param {string} calendarViewId
 * @param {Date|string} date
 */
export function getSaveTemplatePeriodDetails(calendarViewId, date) {
  const titleKeyByView = {
    [EVENT_SHIFT_VIEW.DAILY]: "scheduler.saveDayAsTemplate",
    [EVENT_SHIFT_VIEW.WEEKLY]: "scheduler.saveWeekAsTemplate",
    [EVENT_SHIFT_VIEW.MONTHLY]: "scheduler.saveMonthlyAsTemplate",
  };
  const introKeyByView = {
    [EVENT_SHIFT_VIEW.DAILY]: "scheduler.saveTemplateIntroDay",
    [EVENT_SHIFT_VIEW.WEEKLY]: "scheduler.saveTemplateIntroWeek",
    [EVENT_SHIFT_VIEW.MONTHLY]: "scheduler.saveTemplateIntroMonth",
  };

  const publishDetails = getPublishPeriodDetails(calendarViewId, date);
  let periodValue = publishDetails.periodValue;
  const anchor = moment(date);
  if (anchor.isValid() && calendarViewId === EVENT_SHIFT_VIEW.WEEKLY) {
    const start = anchor.clone().startOf("week");
    const end = anchor.clone().endOf("week");
    periodValue = `${start.format("MMM D")} - ${end.format("MMM D")}`;
  } else if (anchor.isValid() && calendarViewId === EVENT_SHIFT_VIEW.MONTHLY) {
    periodValue = anchor.format("MMMM YYYY");
  } else if (anchor.isValid() && calendarViewId === EVENT_SHIFT_VIEW.DAILY) {
    periodValue = anchor.format("MMM D");
  }

  return {
    titleKey:
      titleKeyByView[calendarViewId] || "scheduler.saveWeekAsTemplate",
    introKey:
      introKeyByView[calendarViewId] || "scheduler.saveTemplateIntroWeek",
    periodValue,
  };
}

/**
 * Builds SchedulerTemplate POST body from the current view + applied filters.
 * `IsShift`: shifts only → true, events only → false, both → null.
 * @param {{
 *   ownerId: number,
 *   name: string,
 *   calendarViewId: string,
 *   currentDate: Date|string,
 *   visibleItems?: Array<{ isShift?: boolean }>,
 *   eventShiftFilter?: string[],
 *   officeIds?: number[],
 *   userIds?: number[],
 * }} options
 */
export function buildSaveSchedulerTemplatePayload({
  ownerId,
  name,
  calendarViewId,
  currentDate,
  visibleItems = [],
  eventShiftFilter = [],
  officeIds = [],
  userIds = [],
}) {
  const { startDate, endDate } = getClearPeriodDateRange(
    calendarViewId,
    currentDate,
  );

  return {
    OwnerId: ownerId,
    Name: name,
    ViewType: getSchedulerTemplateViewType(calendarViewId),
    SourceStartDate: startDate,
    SourceEndDate: endDate,
    UserIds: userIds || [],
    OfficeIds: officeIds || [],
    IsShift: resolveDeleteRangeIsShift({
      clearableItems: visibleItems,
      eventShiftFilter,
    }),
  };
}
